// extracted by mini-css-extract-plugin
export default {"codeLogin":"BBindEmail-module_codeLogin_cc939bae","sendCode":"BBindEmail-module_sendCode_f7126d32","waitToSendCode":"BBindEmail-module_waitToSendCode_a54a51b5"};